<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <v-layout row wrap align-center style="margin-top:20px;">
                    <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 300px">Dammmam, Saudi Arabia</v-btn>
                    <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 20px">Jubel Ali, UAE</v-btn>
                    <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 20px">Port Klang, Malasia</v-btn>
                  </v-layout>
                  <v-flex d-flex style="margin-top:40px;margin-bottom:40px">
                    <v-card style="margin-top:20px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">HUB Management Booking</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs3 child-flex>
                            <v-layout row wrap>
                              <label style="margin-top:20px;margin-right: 10px">Show</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                              ></v-overflow-btn>
                              <label style="margin-top:20px;margin-left: 10px">Entries</label>
                            </v-layout>
                          </v-flex>
                          <v-flex xs3 child-flex></v-flex>
                          <v-flex xs6 child-flex>
                            <v-layout row wrap>
                              <v-text-field
                                label="Search"
                              ></v-text-field>
                              <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show1"
                          style="margin-top:20px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.salesorderno}}</td>
                            <td class="text-xs-left">{{ props.item.bookingno}}</td>
                            <td class="text-xs-left">{{ props.item.from}}</td>
                            <td class="text-xs-left">{{ props.item.to}}</td>
                            <td class="text-xs-left">{{ props.item.bookingdate}}</td>
                            <td class="text-xs-left">{{ props.item.containerrequired_20_ft}} | {{ props.item.containerrequired_40_ft}}</td>
                            <td class="text-xs-left">{{ props.item.totalcontainercount}}</td>
                            <td class="text-xs-left"><a v-on:click="viewdetails()">View Details</a></td>
                          </template>
                        </v-data-table>
                        <v-layout row wrap style="margin-top: 40px">
                          <label style="margin-left:20px">As on Date : </label>
                          <label style="margin-left:40px">Cumulative Inventory: </label>
                        </v-layout>
                        <h3 style="margin-top:20px;margin-bottom: 20px" v-show="show4">Container Level Information for Booking No:</h3>
                        <v-data-table
                          :headers="headers1"
                          :items="desserts1"
                          class="elevation-1"
                          style="margin-top:20px;margin-bottom: 40px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.containerno}}</td>
                            <td class="text-xs-left">{{ props.item.containertype}}</td>
                            <td class="text-xs-left">{{ props.item.commodity}}</td>
                            <td class="text-xs-left">{{ props.item.cargodescription}}</td>
                            <td class="text-xs-left">{{ props.item.tonnage}}</td>
                            <td class="text-xs-left">{{ props.item.currantlocation}}</td>
                            <td class="text-xs-left">{{ props.item.daysremaining}}</td>
                            <td class="text-xs-left">{{ props.item.changetype}}</td>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'salesorderno' },
        { text: 'Booking No', value: 'bookingno' },
        { text: 'From', value: 'from' },
        { text: 'To', value: 'to' },
        { text: 'Booking Date', value: 'bookingdate' },
        { text: 'Container Required 20ft | 40ft', value: 'containerrequired_20_ft' },
        { text: 'Total Container Count', value: 'totalcontainercount' },
        { text: 'Action tab', value: 'actiontab' }
      ],
      desserts: [
        {
          no: '1',
          salesorderno: '',
          bookingno: '',
          from: '',
          to: '',
          bookingdate: '',
          containerrequired_20_ft: '',
          containerrequired_40_ft: '',
          totalcontainercount: ''
        },
        {
          no: '2',
          salesorderno: '',
          bookingno: '',
          from: '',
          to: '',
          bookingdate: '',
          containerrequired_20_ft: '',
          containerrequired_40_ft: '',
          totalcontainercount: ''
        },
        {
          no: '3',
          salesorderno: '',
          bookingno: '',
          from: '',
          to: '',
          bookingdate: '',
          containerrequired_20_ft: '',
          containerrequired_40_ft: '',
          totalcontainercount: ''
        }
      ],
      headers1: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container No', value: 'containerno' },
        { text: 'Container Type', value: 'containertype' },
        { text: 'Commodity', value: 'commodity' },
        { text: 'Cargo Description', value: 'cargodescription' },
        { text: 'Tonnage', value: 'tonnage' },
        { text: 'Current Location', value: 'currantlocation' },
        { text: 'Days Remaining', value: 'daysremaining' },
        { text: 'Change Type', value: 'changetype' }
      ],
      desserts1: [
        {
          no: '1',
          containerno: '',
          containertype: '',
          commodity: '',
          cargodescription: '',
          tonnage: '',
          currantlocation: '',
          daysremaining: '',
          changetype: ''
        },
        {
          no: '2',
          containerno: '',
          containertype: '',
          commodity: '',
          cargodescription: '',
          tonnage: '',
          currantlocation: '',
          daysremaining: '',
          changetype: ''
        },
        {
          no: '3',
          containerno: '',
          containertype: '',
          commodity: '',
          cargodescription: '',
          tonnage: '',
          currantlocation: '',
          daysremaining: '',
          changetype: ''
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false
    }
  },
  mounted () {
    console.log('warehouse management page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
    },
    viewdetails () {
      this.show4 = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Hubmanagement.vue